<template>
  <v-select
    v-model="purpose"
    :items="purposes"
    :label="$t('crudMyBookings.hReason')"
    prepend-icon="mdi-account"
    color="grey"
    clearable
    @input="onInput"
  />
</template>

<script>
import i18n from "@/i18n";
import BookingReasons from "@/models/BookingReasons";

export default {
  name: "ReasonFilter",
  data: () => ({
    purposes: i18n.t("booking.purposes"),
    purpose: null,
  }),
  methods: {
    onInput() {
      this.$emit(
        "updateFilter",
        BookingReasons[this.purposes.indexOf(this.purpose)]
      );
    },
  },
};
</script>
